<template>
  <RootModalComponent
    :name="$MODAL_NAME.CALL_TICKET_MOBILE"
    :mobile-type="$MODAL_TYPE_MOBILE.BUBBLE_FLAT"
    :frame="true"
  >
    <div class="call-ticket-modal">
      <div
        v-if="$store.mobileTicketModalData"
        class="call-ticket-modal__inner"
      >
        <div class="call-ticket-modal__top">
          <div class="call-ticket-modal__top__number">
            <i class="ri-coupon-3-line" />
            {{ $store.mobileTicketModalData.ticket.prefix + $store.mobileTicketModalData.ticket.number }}
          </div>
          <div class="call-ticket-modal__top__timer">
            <Timer
              :ticket-time="$store.mobileTicketModalData.ticket.created"
              :critical-time="($store.deviceStartData.unit_settings.time_of_waiting * 75) / 100"
            />
          </div>
        </div>
        <div class="call-ticket-modal__tags">
          <ul>
            <li
              v-for="(tag, idx) in tags"
              :key="idx"
            >
              {{ tag }}
            </li>
          </ul>
        </div>
        <div class="call-ticket-modal__service">
          {{ service.name[$store.activeLanguage] }}
        </div>
        <div
          class="call-ticket-modal__buttons"
          :class="{'is--group': $store.contextMenuActions && $store.contextMenuActions.length > 1}"
        >
          <button
            v-if="CALL_ACTION"
            class="secondary"
            :class="{'is--disabled': !buttonsAccess}"
            :disabled="!buttonsAccess"
            @click="ticketCall"
          >
            <i class="ri-notification-3-line" />
            <span class="text">{{ 'd_ws_context_call' | translate }}</span>
          </button>
          <button
            v-if="BACK_TO_ALIVE_ACTION"
            class="secondary"
            :class="{'is--disabled': !buttonsAccess}"
            :disabled="!buttonsAccess"
            @click="ticketRedirect"
          >
            <i class="ri-arrow-go-forward-fill" />
            <span class="text">{{ 'd_ws_ticket_redirect' | translate }}</span>
          </button>
          <button
            v-if="ISSUED_ACTION"
            class="secondary"
            :class="{'is--disabled': !buttonsAccess}"
            @click="orderIssued"
          >
            <i class="ri-barcode-box-line" />
            <span class="text">{{ 'd_ws_context_issued' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </RootModalComponent>
</template>

<script>

import RootModalComponent from './RootModalComponent'
import Timer from '../controls/Timer'
import {CONTEXT_MENU_ACTIONS, REDIRECT_MODE, USER_STATUSES} from "../../config";

export default {
  components: {
    RootModalComponent,
    Timer
  },
  computed: {
    service () {
      return this.$ticketService.getCurrentService(this.$store.mobileTicketModalData.ticket.office_service_id);
    },
    ticket () {
      return this.$store.mobileTicketModalData.ticket;
    },
    tags () {
      let allTags = [];

      if (this.ticket && this.ticket.ticket_servicing_list && this.ticket.ticket_servicing_list.length) {
        allTags = this.ticket.ticket_servicing_list[this.ticket.ticket_servicing_list.length - 1].tag;
      }

      return allTags
    },
    buttonsAccess() {
      return !this.$store.currentTicket && !this.$store.currentTicketServicing
    },
    CONTEXT_MENU_ACTIONS() {
      return CONTEXT_MENU_ACTIONS
    },
    CALL_ACTION() {
      return !!this.$store.contextMenuActions.find(action => action === this.CONTEXT_MENU_ACTIONS.CALL)
    },
    BACK_TO_ALIVE_ACTION() {
      return !!this.$store.contextMenuActions.find(action => action === this.CONTEXT_MENU_ACTIONS.BACK_TO_ALIVE)
    },
    ISSUED_ACTION() {
      return !!this.$store.contextMenuActions.find(action => action === this.CONTEXT_MENU_ACTIONS.ISSUED)
    },
    REDIRECT_MODE() {
      return REDIRECT_MODE
    }
  },
  methods: {
    ticketRedirect() {
      if (this.buttonsAccess) {
        this.$store.redirectMode = this.REDIRECT_MODE.BACK_TO_ALIVE;
        this.$modal.show(this.$MODAL_NAME.REDIRECT);
      }
    },
    ticketCall() {
      if (this.buttonsAccess) {
        this.$ticketService.callTicket(this.ticket.id).then((resp) => {
          this.$store.currentTicket = this.ticket;
          this.$store.currentStatus = USER_STATUSES.WORKING;
          this.$store.currentTicketServicing = resp.data;
          this.$eventEmitter.emit(this.$eventEmitter.eventTypes.MOBILE_CALL_TICKET);
          this.$modal.hide(this.$MODAL_NAME.CALL_TICKET_MOBILE);
        }).catch((err) => {
          if(err.response && err.response.data && err.response.data.code && err.response.data.code === this.$ERROR_CODE.BAD_REQUEST) {
            this.$eventEmitter.emit(this.$eventEmitter.eventTypes.WORKSPACE_RELOAD);
          }
        });
      }
    },
    orderIssued() {
      this.$ticketService.orderIssued(this.ticket).then(() => {
        this.$modal.hide(this.$MODAL_NAME.CALL_TICKET_MOBILE);
      });
    },
  }
}
</script>

<style lang="scss" scoped>
  .call-ticket-modal {
    &__inner {
      padding: 16px 16px 20px 16px;
    }
    &__top {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      &__number {
        display: flex;
        align-items: center;
        font-weight: 600;
        font-size: 22px;
        font-feature-settings: 'zero' on;
        i {
          font-size: 24px;
          font-weight: normal;
          margin-right: 4px;
        }
      }
      &__timer {
        margin-left: auto;
        color: var(--accent-orange);
      }
    }
    &__tags {
      margin-bottom: 8px;
      ul {
        margin: 0;
        padding: 0;
        list-style: none;
        display: flex;
        li {
          font-size: 12px;
          line-height: 130%;
          color: #fff;
          background: var(--label-tetriary);
          padding: 0 4px;
          border-radius: 4px;
          margin-right: 8px;
        }
      }
    }
    &__service {
      font-size: 16px;
      font-weight: 300;
      line-height: 150%;
      margin-bottom: 8px;
    }
    &__action {
      display: flex;
      align-items: center;
      font-weight: 600;
      font-size: 12px;
      line-height: 130%;
      margin-bottom: 36px;
      i {
        vertical-align: middle;
        font-size: 20px;
        margin-right: 4px;
        font-weight: normal;
      }
    }
    &__buttons {
      display: flex;
      &.is--group {
        button {
          width: auto;
          padding-left: 12px;
          padding-right: 8px;
          &:first-child {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
          }
          &:last-child {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            border-left: 0;
          }
        }
      }
    }
  }
  @media (max-width: 425px) {
  }
</style>
